import axios from "axios";
import {
  PiggyBank,
  Briefcase,
  TrendingUp,
  CreditCard,
  Zap,
  Scale,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "burgeon_token";
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CURRENCY = "#";

export function fmt(amount) {
  const n = Math.round(Number(amount) || 0);
  const sign = n < 0 ? "-" : "";
  return `${sign}${CURRENCY}${Math.abs(n).toLocaleString("en-GB")}`;
}

export function fmtDelta(amount) {
  const n = Math.round(Number(amount) || 0);
  if (n === 0) return `${CURRENCY}0`;
  const sign = n > 0 ? "+" : "-";
  return `${sign}${CURRENCY}${Math.abs(n).toLocaleString("en-GB")}`;
}

// Category visual metadata (colors mirror the design guidelines)
export const CATEGORIES = {
  SAVE: {
    key: "SAVE",
    label: "Save",
    face: 1,
    Icon: PiggyBank,
    hex: "#10B981",
    text: "text-emerald-400",
    badge: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30",
    border: "border-emerald-500/40",
    bg: "bg-emerald-500/10",
    glow: "shadow-emerald-500/20",
    gradient: "from-emerald-500/25 to-emerald-500/5",
  },
  EARN: {
    key: "EARN",
    label: "Earn",
    face: 2,
    Icon: Briefcase,
    hex: "#3B82F6",
    text: "text-blue-400",
    badge: "bg-blue-500/20 text-blue-300 border-blue-500/30",
    border: "border-blue-500/40",
    bg: "bg-blue-500/10",
    glow: "shadow-blue-500/20",
    gradient: "from-blue-500/25 to-blue-500/5",
  },
  INVEST: {
    key: "INVEST",
    label: "Invest",
    face: 3,
    Icon: TrendingUp,
    hex: "#8B5CF6",
    text: "text-purple-400",
    badge: "bg-purple-500/20 text-purple-300 border-purple-500/30",
    border: "border-purple-500/40",
    bg: "bg-purple-500/10",
    glow: "shadow-purple-500/20",
    gradient: "from-purple-500/25 to-purple-500/5",
  },
  SPEND: {
    key: "SPEND",
    label: "Spend",
    face: 4,
    Icon: CreditCard,
    hex: "#F97316",
    text: "text-orange-400",
    badge: "bg-orange-500/20 text-orange-300 border-orange-500/30",
    border: "border-orange-500/40",
    bg: "bg-orange-500/10",
    glow: "shadow-orange-500/20",
    gradient: "from-orange-500/25 to-orange-500/5",
  },
  LIFE_EVENT: {
    key: "LIFE_EVENT",
    label: "Life Event",
    face: 5,
    Icon: Zap,
    hex: "#22D3EE",
    text: "text-cyan-400",
    badge: "bg-cyan-500/20 text-cyan-300 border-cyan-500/30",
    border: "border-cyan-500/40",
    bg: "bg-cyan-500/10",
    glow: "shadow-cyan-500/20",
    gradient: "from-cyan-500/25 to-cyan-500/5",
  },
  DEBT: {
    key: "DEBT",
    label: "Debt",
    face: 6,
    Icon: Scale,
    hex: "#FB7185",
    text: "text-rose-400",
    badge: "bg-rose-500/20 text-rose-300 border-rose-500/30",
    border: "border-rose-500/40",
    bg: "bg-rose-500/10",
    glow: "shadow-rose-500/20",
    gradient: "from-rose-500/25 to-rose-500/5",
  },
};

export const FACE_TO_CATEGORY = {
  1: "SAVE",
  2: "EARN",
  3: "INVEST",
  4: "SPEND",
  5: "LIFE_EVENT",
  6: "DEBT",
};
